import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 bg-black/80 hover:bg-black text-kitco-gold px-6 py-2.5 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 backdrop-blur-sm border border-kitco-gold/30 group flex items-center gap-2"
          aria-label={t('backToTop')}
          title={t('backToTop')}
        >
          <ArrowUp className="h-4 w-4 group-hover:-translate-y-1 transition-transform" />
          <span className="text-sm font-medium">{t('backToTop')}</span>
        </button>
      )}
    </>
  );
};

export default BackToTop;
